<template>
  <div class="md-layout">
    <group-card title="Capacity Analysis" icon="attach_money">
      <capacity-analysis-component
        :application="application"
        v-model="applicant"
      />
    </group-card>
  </div>
</template>

<script>
import { GroupCard } from "@/components";
import CapacityAnalysisComponent from "@/components/CapacityAnalysis/CapacityAnalysisComponent.vue";

export default {
  components: {
    CapacityAnalysisComponent,
    GroupCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },
  },
};
</script>
